const sum = 'Summe';
const ht = 'HT';
const nt = 'NT';

const lookup = [
  { code: '1-1.8.0', tarif: sum },
  { code: '1-1.8.1', tarif: ht },
  { code: '1-1.8.2', tarif: nt },
  { code: '1-1:1.8.1', tarif: ht },
  { code: '1-1:1.8.2', tarif: nt },
  { code: '1-1:1.29.0', tarif: '' },
  { code: '1-1:3.29.0', tarif: '' },
  { code: '1-8:1.8.1', tarif: ht },
  { code: '1-9:1.8.2', tarif: nt },
  { code: '1-0:1.8.0', tarif: sum },
  { code: '1-1:1.8.0', tarif: sum },
  { code: '1-0:1.8.1', tarif: ht },
  { code: '1-0:1.8.2', tarif: nt },
  { code: '7-3.0.0', tarif: 'Gas' },
  { code: '1-1:1.8.3', tarif: '' },
  { code: '1-1:1.8.4', tarif: '' },
  { code: '1-1:0.8.0', tarif: '' },
  { code: '1-8:1.8.0', tarif: sum },
  { code: '1-65:1.8.0', tarif: sum },
  { code: '1-0.1.8.1', tarif: ht },
  { code: '1-0:2.8.1', tarif: 'Einspeisung' },
  { code: '1-1:0.8.1', tarif: '' },
  { code: '1-1:0.8.2', tarif: '' },
  { code: '1-0.1.8.2', tarif: nt },
  { code: '1-65:1.8.1', tarif: ht },
  { code: '1-65:1.8.2', tarif: nt },
  { code: '1-65:1.8.63', tarif: '' },
];

export const formatObis = (obisString: string | null | undefined) => {

  if (obisString == null) {
    return '';
  }
  return lookup.find(l => l.code == obisString)?.tarif ?? '';
};
